<!-- BANNER
        ================================================== -->
<section class="bg-banner pt-0 pb-0 banner-style03">
    <div class="hero-slider-wrapper">
        <div class="custom-swiper swiper">
            <div class="swiper-wrapper">

                <div class="custom-slide swiper-slide">
                    <img src="/assets/images/banner/banner7.jpg" class="desktop-show" alt="Red Monk Wellness" />
                    <img src="/assets/images/banner/banner7m.jpg" class="mobile-show" alt="Red Monk Wellness" />
                </div>


           <div class="custom-slide swiper-slide">
                    <img src="/assets/images/banner/banner1.jpeg" class="desktop-show" alt="Red Monk Wellness" />
                    <img src="/assets/images/banner/banner1m.jpeg" class="mobile-show" alt="Red Monk Wellness" />
                </div>

                <div class="custom-slide swiper-slide">
                    <img src="/assets/images/banner/banner2.jpeg" class="desktop-show" alt="Red Monk Wellness" />
                    <img src="/assets/images/banner/banner2m.jpeg" class="mobile-show" alt="Red Monk Wellness" />
                </div>

                <div class="custom-slide swiper-slide">
                    <img src="/assets/images/banner/banner8.jpg" class="desktop-show" alt="Red Monk Wellness" />
                    <img src="/assets/images/banner/banner8m.jpg" class="mobile-show" alt="Red Monk Wellness" />
                </div>

                <div class="custom-slide swiper-slide">
                    <img src="/assets/images/banner/banner3.jpeg" class="desktop-show" alt="Red Monk Wellness" />
                    <img src="/assets/images/banner/banner3m.jpeg" class="mobile-show" alt="Red Monk Wellness" />
                </div>

                <div class="custom-slide swiper-slide">
                    <img src="/assets/images/banner/banner4.jpeg" class="desktop-show" alt="Red Monk Wellness" />
                    <img src="/assets/images/banner/banner4m.jpeg" class="mobile-show" alt="Red Monk Wellness" />
                </div>

                <div class="custom-slide swiper-slide">
                    <div class="banner-wrapper">
                        <img src="/assets/images/banner/banner5.jpeg" class="desktop-show" alt="Red Monk Wellness" />
                        <img src="/assets/images/banner/banner5m.jpeg" class="mobile-show" alt="Red Monk Wellness" />

                        <div class="visit-banner-button">
                            <a href="#enquiry" class="btn clinic-btn">
                                <i class="fas fa-hospital"></i> Know More About Clinic
                            </a>

                            <a href="#enquiry" class="btn appoinment-btn">
                                <i class="fas fa-calendar-check"></i> Make An Appointment
                            </a>
                        </div>
                    </div>
                </div>

                <div class="custom-slide swiper-slide">
                    <div class="banner-wrapper">
                        <img src="/assets/images/banner/banner6.jpeg" class="desktop-show" alt="Red Monk Wellness" />
                        <img src="/assets/images/banner/banner6m.jpeg" class="mobile-show" alt="Red Monk Wellness" />

                        <div class="visit-banner-button">
                            <a href="#enquiry" class="btn clinic-btn">
                                <i class="fas fa-hospital"></i> Know More About Clinic
                            </a>

                            <a href="#enquiry" class="btn appoinment-btn">
                                <i class="fas fa-calendar-check"></i>
                                Make An Appointment
                            </a>
                        </div>
                    </div>
                </div> 



            </div>

            <div class="custom-swiper-button custom-swiper-button-prev">
                <i class="fas fa-chevron-left"></i>
            </div>

            <div class="custom-swiper-button custom-swiper-button-next">
                <i class="fas fa-chevron-right"></i>
            </div>

            <!-- <div class="custom-pagination swiper-pagination"></div> -->

        </div>
    </div>
</section>


<!-- Services Section 1-->
<section class="services-section">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Our Services</h2>
            <p class="lead text-muted mt-3">Transform your wellness journey with our expert care and personalized
                solutions</p>
        </div>

        <div class="row">

            <!-- Service 1 -->
            <div class="col-lg-12 service-wrapper">
                <div class="service-card">
                    <div class="service-inner">
                        <!-- Image Side -->
                        <div class="service-image-side">
                            <!-- <div class="service-badge">
                                <i class="fas fa-shield-virus"></i>
                            </div> -->
                            <img src="/assets/images/services/houseof-hydration-thumb.png?w=600" alt="House of hydration thumb">

                        </div>

                        <!-- Content Side -->
                        <div class="service-content-side">
                            <h3 class="service-title">Wellness I.V. Therapy</h3>
                            <h3 class="service-subtitle">Anti-Ageing Wellness I.V.</h3>
                            <p class="service-desc">
                                Our holistic therapies cover the entire spectrum of wellness. Some of our popular and
                                proven I.V. drips, specially curated to enhance your lifestyle and health.
                            </p>
                            <!-- <button class="read-more-btn"
                                (click)="scrollToSection('wellness'); $event.preventDefault()">
                                Know More
                            </button> -->
                            <button class="read-more-btn" (click)="scrollToSection('wellness')">
                                Know More
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</section>


<!-- 2. House of Hydration -->

@if (showWellness) {
<section class="bg-grey-light" id="wellness">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Wellness I.V. Therapy</h2>
            <!-- <p class="lead text-danger">Anti-Ageing Wellness IV’s</p>
            <p class="mt-3">Our Anti-Ageing IV Drips, Specially Curated to Enhance your Lifestyle & Health.</p> -->
        </div>


        <div class="row g-4">
            @if (loadingItems) {
            <div class="col-12 text-center text-muted">Loading...</div>
            }
            @for (p of wellnessItems; track p.TreatmentItemID) {
            <div class="col-lg-4 col-md-6">
                <div class="hoh-service-card">
                    <div class="hoh-card-image pkg-shape">
                        @if (p.Image && !failedImages.has('p' + p.TreatmentItemID)) {
                        <img [src]="imgUrl(p.Image)" [alt]="p.TreatmentName" loading="lazy"
                            (error)="onImgError('p' + p.TreatmentItemID)">
                        } @else {
                        <span class="pkg-alt">{{ p.TreatmentName }}</span>
                        }
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">{{ p.TreatmentName }}</h4>
                        @if (p.Benefits) {
                        <h6 class="text-dark">{{ p.Benefits }}</h6>
                        }
                        <p class="mt-1 text-dark">{{ p.Description }}</p>
                    </div>
                </div>
            </div>
            } @empty {
            @if (!loadingItems) {
            <div class="col-12 text-center text-muted">No treatments available.</div>
            }
            }
        </div>
    </div>
</section>

}



<!--Services Section 2-->
<section class="services-section bg-blue">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title"> Beauty I.V. Therapy</h2>
        </div>

        <div class="row align-items-center">

            <!-- Service 2 -->
            <div class="col-lg-12 service-wrapper ">
                <div class="service-card">
                    <div class="service-inner">
                        <!-- Content Side (Reversed on mobile) -->
                        <div class="service-content-side">
                            <h3 class="service-title">The Cosmetic IV Collection</h3>
                            <!-- <h3 class="service-subtitle">The Cosmetic IV Collection</h3> -->
                            <p class="service-desc">
                                Beyond the realm of wellness, the House of Hydration has also ventured into the world of
                                cosmetic IV therapy, where beauty and science come together in perfect harmony. In other
                                words, skincare and self-care intertwine at the cellular level, where results are far
                                more in-depth than what over-the-counter creams and supplements can ever offer.</p>
                            <p class="service-desc">
                                With the robust backing of advanced formulations and an expert fraternity of experienced
                                medical experts, House of Hydration has brought to the table a carefully curated line of
                                premium cosmetic drips designed to bolster health, beauty and performance from deep
                                within. Each drip is more than just mere therapy - it’s actually an experience specially
                                crafted for those who believe in investing in themselves.
                            </p>
                            <!-- <button class="read-more-btn" (click)="scrollToSection('beauty'); $event.preventDefault()">
                                Know More
                            </button> -->
                            <button class="read-more-btn" (click)="scrollToSection('beauty')">
                                Know More
                            </button>
                        </div>

                        <!-- Image Side -->
                        <div class="service-image-side">
                            <!-- <div class="service-badge">
                                <i class="fas fa-tint"></i>
                            </div> -->
                            <img src="/assets/images/services/timeless-monk-thumb.png?w=600" alt="Timeless Monk Thumbs">
                        </div>


                    </div>
                </div>
            </div>

        </div>

    </div>
</section>


<!--Beauty Section start-->

@if (showBeauty) {

<div class="beauty-section" id="beauty">
    <!-- Cosmetic IV Collection start -->

    <div class="container mb-5">
        <div class="section-header">
            <p class="lead text-danger">Beauty I.V. Therapy</p>
            <h2 class="section-title">The Cosmetic I.V. Collection</h2>
            <!-- <p class="lead text-danger">Anti-Ageing Wellness IV’s</p> -->
            <p class="mt-3">With the powerful backing of advanced formulations and an expert fraternity of experienced
                medical experts, Red Monk Wellness has brought to the table a carefully curated line of premium cosmetic
                drips designed to bolster health, beauty and performance from deep within.</p>
        </div>


        <div class="row g-4">
            @if (loadingItems) {
            <div class="col-12 text-center text-muted">Loading...</div>
            }
            @for (p of beautyItems; track p.TreatmentItemID) {
            <div class="col-lg-4 col-md-6">
                <div class="hoh-service-card">
                    <div class="beauty-iv-shape">
                        @if (p.Image && !failedImages.has('p' + p.TreatmentItemID)) {
                        <img [src]="imgUrl(p.Image)" [alt]="p.TreatmentName" loading="lazy"
                            (error)="onImgError('p' + p.TreatmentItemID)">
                        } @else {
                        <span class="pkg-alt">{{ p.TreatmentName }}</span>
                        }
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">{{ p.TreatmentName }}</h4>
                        @if (p.Benefits) {
                        <h6 class="text-dark">{{ p.Benefits }}</h6>
                        }
                        <p class="mt-1 text-dark">{{ p.Description }}</p>
                    </div>
                </div>
            </div>
            } @empty {
            @if (!loadingItems) {
            <div class="col-12 text-center text-muted">No treatments available.</div>
            }
            }
        </div>
    </div>


    <!---Treatment start    -->
    <div class="container">

        <!-- Heading -->
        <div class="section-header">
            <h2 class="section-title">Beauty Treatments</h2>
        </div>


        <div class="row g-4 justify-content-center">
            @if (loadingTreatments) {
            <div class="col-12 text-center text-muted">Loading...</div>
            }
            @for (c of treatmentCategories; track c.category) {
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-1">
                <div class="beauty-thumbnail">
                    <div class="treat-shape">
                        @if (c.image && !failedImages.has('c' + c.category)) {
                        <img [src]="imgUrl(c.image, treatmentImageBase)" [alt]="c.category" loading="lazy"
                            (error)="onImgError('c' + c.category)">
                        } @else {
                        <span class="pkg-alt">{{ c.category }}</span>
                        }
                    </div>
                    <div class="beauty-content">
                        <h5 class="beauty-title">{{ c.category }}</h5>
                        <a [routerLink]="c.route" [queryParams]="{ category: c.category }" class="beauty-btn">View
                            More</a>
                    </div>
                </div>
            </div>
            } @empty {
            @if (!loadingTreatments) {
            <div class="col-12 text-center text-muted">No treatments available.</div>
            }
            }
        </div>
    </div>

</div>

}






<!-- CTA Section start-->
<section class="cta-section" id="enquiry">
    <div class="container cta-content">
        <div class="row align-items-center g-5">

            <!-- Left Side Content -->
            <div class="col-lg-5">
                <div class="pe-lg-4">
                    <span class="badge bg-white text-dark px-4 py-3 mb-4 fs-6">
                        <i class="bi bi-droplet-fill me-2"></i> INSTANT CONSULTATION
                    </span>

                    <h2 class="cta-heading text-white">Ready to Feel Rejuvenated?</h2>
                    <p class="lead opacity-90 mb-3">
                        Book your personalized IV therapy session with our expert team.
                        Experience science-backed wellness like never before.
                    </p>

                    <!-- Contact Information -->
                    <div class="cta-contact-info">
                        <!-- Phone -->
                        <a href="tel:+916262662662" class="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                                fill="white">
                                <path
                                    d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.07 21 3 13.93 3 5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.24.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z">
                                </path>
                            </svg>
                            <div>
                                Call us now<br>
                                <strong>+916262662662</strong>
                            </div>
                        </a>

                        <!-- WhatsApp -->
                        <a href="https://api.whatsapp.com/send?phone=916262662662&text=I%20am%20interested%20!%20Please%20share%20me%20more%20details%20about%20Red%20Monk%20Welness%20!"
                            target="_blank" class="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
                                fill="white">

                                <path
                                    d="M16.04 3C8.84 3 3 8.74 3 15.82c0 2.5.74 4.93 2.13 7L3 29l6.37-2.05a13.2 13.2 0 0 0 6.67 1.82h.01C23.2 28.77 29 23.03 29 15.95 29 8.87 23.2 3 16.04 3zm0 23.6c-2.06 0-4.08-.55-5.85-1.6l-.42-.25-3.78 1.22 1.23-3.68-.28-.44a10.5 10.5 0 0 1-1.64-5.63c0-5.87 4.82-10.65 10.75-10.65 5.92 0 10.74 4.78 10.74 10.65 0 5.88-4.82 10.67-10.75 10.67zm5.89-8.03c-.32-.16-1.9-.93-2.2-1.03-.3-.1-.52-.16-.74.16-.22.31-.85 1.03-1.05 1.24-.19.21-.39.24-.71.08-.32-.16-1.35-.49-2.57-1.56-.95-.83-1.59-1.85-1.78-2.16-.19-.31-.02-.48.14-.64.14-.14.32-.37.48-.55.16-.18.21-.31.32-.52.1-.21.05-.39-.03-.55-.08-.16-.74-1.77-1.01-2.43-.27-.64-.54-.55-.74-.56h-.63c-.21 0-.55.08-.84.39-.29.31-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.22 3.37 5.38 4.73.75.32 1.34.51 1.8.65.76.24 1.45.21 2 .13.61-.09 1.9-.78 2.17-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z">
                                </path>
                            </svg>
                            <div>
                                Chat on WhatsApp<br>
                                <strong>+91 6262662662</strong>
                            </div>
                        </a>

                        <!-- Email -->
                        <a href="mailto:info@redmonkwellness.com">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                                fill="white">
                                <path
                                    d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 3.2-8 5.3-8-5.3V6l8 5.3L20 6v1.2z">
                                </path>
                            </svg>
                            <div>
                                Send us an email<br>
                                <strong>info@redmonkwellness.com</strong>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Right Side Form -->
            <div class="col-lg-7">
                <div class="form-card">
                    <h3 class="mb-3 pb-3 border-bottom">
                        Enquire for More Details
                    </h3>

                    <div id="formErrors" class="text-danger mb-2" style="display:none;"></div>
                    <div id="msgSubmit" class="text-success hidden mb-2"></div>

                    <form id="enquiry-form" action="#" method="post">
                        <div class="row">
                            <div class="col-md-6">
                                <!-- <input type="text" class="form-control" placeholder="Your name here*" required> -->
                                <input class="form-control" id="name" [(ngModel)]="enquiryForm.Name" type="text"
                                    name="name" placeholder="Your name here*" />
                                <span id="error-fname" class="error-message"></span>
                            </div>
                            <div class="col-md-6">
                                <!-- <input type="email" class="form-control" placeholder="Your email here*" required> -->
                                <input class="form-control" id="email" [(ngModel)]="enquiryForm.Email" type="text"
                                    name="email" placeholder="Your email here*" />
                                <span id="error-email" class="error-message"></span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <input class="form-control" id="phone" [(ngModel)]="enquiryForm.Phone" type="text"
                                    name="phone" placeholder="Your phone here*" />
                                <span id="error-phone" class="error-message"></span>
                            </div>
                            <!-- <div class="col-md-6">
                                <input class="form-control" id="subject" [(ngModel)]="enquiryForm.Location" type="text"
                                    name="subject" placeholder="Your location here*" />
                                <span id="error-location" class="error-message"></span>
                            </div> -->

                            <div class="col-md-6">
                                <select class="form-control" id="city" [(ngModel)]="enquiryForm.CityID" name="city">
                                    <option [ngValue]="null" disabled>Select City*</option>
                                    <option *ngFor="let city of cities" [ngValue]="city.CityID">{{ city.CityName }}
                                    </option>
                                </select>
                                <span id="error-location" class="error-message"></span>
                            </div>

                        </div>

                        <p class="mt-1 mb-3 fw-bold text-dark">Interested in*</p>
                        <div class="row">
                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="IV Therapy" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">IV Therapy</span>
                                </label>

                            </div>
                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="Treatments" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">Treatments</span>
                                </label>
                            </div>

                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="Both(IV & Treatments)" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">Both(IV & Treatments)</span>
                                </label>
                            </div>

                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="Not Sure" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">Not Sure</span>
                                </label>
                            </div>

                            <span id="error-brand" class="error-message"></span>
                        </div>

                        <textarea class="form-control" [(ngModel)]="enquiryForm.Message" id="message" name="message"
                            rows="" placeholder="Your message here*"></textarea>
                        <span id="error-message" class="error-message"></span>

                        <div class="form-check mt-2 mb-2">
                            <label class="consent-label">
                                <input type="checkbox" class="consent-checkbox" [(ngModel)]="enquiryForm.consent"
                                    id="consent" name="consent" required>
                                <span class="consent-text">
                                    By submitting this form, you hereby grant us permission
                                    to contact you via
                                    <span>SMS, WhatsApp, RCS, Email</span>, and any other
                                    communication channel.
                                </span>
                            </label>

                            <span id="error-message" class="error-message"></span>

                        </div>

                        <div class="text-start">
                            <!-- <button type="submit" class="submit-btn w-100">
                                SUBMIT ENQUIRY
                            </button> -->
                            <button class="submit-btn" type="button" (click)="submitEnquiryForm()" id="submitBtn">
                                <span id="submitText">Submit</span>
                                <span id="submitLoader" style="display:none;">⏳</span>
                            </button>
                        </div>
                        <div class="quform-loading-wrap text-start">
                            <span class="quform-loading"></span>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section end-->


<!-- Why Red Monk Wellness Section -->
<section class="why-section">
    <div class="container">
        <h2 class="stat-section-title">Why Red Monk Wellness?</h2>

        <div class="row g-4">
            <!-- Stat 1 -->
            <div class="col-lg-3 col-md-6">
                <div class="stat-card h-100">
                    <div class="icon-wrapper">
                        <i class="fas fa-droplet"></i>
                    </div>
                    <div class="stat-number">1000+</div>
                    <div class="stat-label">Drips Delivered</div>
                </div>
            </div>

            <!-- Stat 2 -->
            <div class="col-lg-3 col-md-6">
                <div class="stat-card h-100">
                    <div class="icon-wrapper">
                        <i class="fas fa-signature"></i>
                    </div>
                    <div class="stat-number">12+</div>
                    <div class="stat-label">Signature Drips</div>
                </div>
            </div>

            <!-- Stat 3 -->
            <div class="col-lg-3 col-md-6">
                <div class="stat-card h-100">
                    <div class="icon-wrapper">
                        <i class="fas fa-medkit"></i>
                    </div>
                    <div class="stat-number">30+</div>
                    <div class="stat-label">Medical Grade Beauty Treatments</div>
                </div>
            </div>

            <!-- Stat 4 -->
            <div class="col-lg-3 col-md-6">
                <div class="stat-card h-100">
                    <div class="icon-wrapper">
                        <i class="fas fa-heart"></i>
                    </div>
                    <div class="stat-number">2000+</div>
                    <div class="stat-label">Happy Customers</div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Media press start========== -->


<section class="press-section">
    <div class="container">

        <h2 class="press-section-title">Press and Media</h2>

        <div class="row g-4">
            <!-- Card 1 -->
            <div class="col-lg-4 col-md-6">
                <div class="press-card">
                    <img src="https://crm-api.redmonkwellness.com/Content/PressMedia/pressmedia_20251222155701195.jpeg"
                        alt="mandavi s mishra" class="img-fluid">
                    <div class="press-card-content">
                        <div class="press-meta">
                            <i class="fas fa-newspaper"></i> Tribune India • Dec 22, 2025
                        </div>
                        <h5>RedMonk Wellness announced House of Hydration with Doorstep IV drips</h5>
                        <a href="https://www.tribuneindia.com/news/business/redmonk-wellness-announced-house-of-hydration-with-doorstep-iv-drips/"
                            class="press-read-more" target="_blank">
                            Read more <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="col-lg-4 col-md-6">
                <div class="press-card">
                    <img src="https://crm-api.redmonkwellness.com/Content/PressMedia/pressmedia_20251222155006509.jpeg"
                        alt="mandavi s mishra" class="img-fluid">
                    <div class="press-card-content">
                        <div class="press-meta">
                            <i class="fas fa-newspaper"></i> Fortune India Exchange • Dec 22, 2025
                        </div>
                        <h5>Motivated to help customers stay healthy and confident</h5>
                        <a href="https://www.redmonkwellness.com/MotivatedToHelpCustomersStayHealthyConfident"
                            class="press-read-more" target="_blank">
                            Read more <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="col-lg-4 col-md-6">
                <div class="press-card">
                    <img src="https://crm-api.redmonkwellness.com/Content/PressMedia/pressmedia_20251222154912978.jpeg"
                        alt="mandavi s mishra - RedMonk Wellness announced House of Hydration​ with Doorstep IV
                                        drips" class="img-fluid">
                    <div class="press-card-content">
                        <div class="press-meta">
                            <i class="fas fa-newspaper"></i> The Times Of India • Dec 22, 2025
                        </div>
                        <h5>Empowered by Better Leadership, India Moves Toward Becoming a 'Vishwaguru'</h5>
                        <a href="https://timesofindia.indiatimes.com/india/empowered-by-better-leadership-india-moves-toward-becoming-a-vishwaguru/articleshow/124810803.cms"
                            class="press-read-more" target="_blank">
                            Read more <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mt-4">
            <a routerLink="/press-media" class="btn btn-primary view-all-btn"
                aria-label="View all press and media coverage">
                View All Press & Media
            </a>
        </div>

    </div>
</section>


<!-- Media press end========== -->


<!-- Team start========== -->

<!-- TEAM -->
<section class="team-section">
    <div class="container">
        <!-- Heading -->
        <!-- <div class="text-center mb-5" data-aos="fade-up">

            <h2 class="section-title">Meet The Team</h2>

            <p class="mx-auto team-subtitle">
                Dedicated wellness experts committed to helping you achieve
                better health, beauty, and confidence.
            </p>
        </div> -->

        <div class="section-header">
            <h2 class="section-title">Meet The Team</h2>
            <p class="lead text-muted mt-3"> Dedicated wellness experts committed to helping you achieve
                better health, beauty, and confidence.</p>
        </div>



        <div class="leader-container">


            <div class="dr-arshi-section">
                <div class="dr-arshi-container">
                    <!-- Circular Image -->
                    <div class="dr-arshi-image-section">
                        <div class="dr-arshi-circle-frame">
                            <img src="assets/images/manadavi-s-mishra.jpeg" alt="Mandavvi Maam" class="leader-avatar">
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="dr-arshi-content-section">
                        <h1 class="dr-arshi-title">Mandavvi S. Mishra</h1>
                        <p class="dr-arshi-subtitle">Founder & Director</p>

                        <div class="dr-arshi-bio">
                            <p>
                                <strong> From Homemaker to Wellness Expert- The Inspiring Journey of Mandavvi S.
                                    Mishra</strong>
                                What began as a personal pursuit of better health turned into a lifelong mission. For
                                Mandavvi S. Mishra, the pursuit of wellness was born from experience, observation, and
                                an unshakable belief that good health is the foundation of everything we are capable of
                                becoming.
                            </p>
                            <p>
                                There was a time when balancing home, family, and her own wellbeing felt like an
                                impossible equation. But instead of surrendering to routine, she began learning-
                                reading, researching, experimenting, sitting down with doctors, and understanding the
                                science behind the body’s needs. What started as curiosity soon evolved into expertise,
                                and expertise became a calling.
                            </p>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Leader 1 -->
            <!-- <div class="leader-box">
                <div class="leader-avatar-wrapper">
                    <img src="assets/images/manadavi-s-mishra.jpg" alt="Mandavvi Maam" class="leader-avatar">
                </div>
                <div class="leader-name">Mandavvi Maam</div>
                <div class="leader-designation">Founder &amp; Director</div> -->
            <!-- <div class="leader-accent-dot"></div> -->
            <!-- </div> -->
            <!-- <div class="leader-box">
                <div class="leader-avatar-wrapper">
                    <img src="assets/images/Dr-Kanishka-Jain.png" alt="Kanishk Jain" class="leader-avatar">
                </div>
                <div class="leader-name">Kanishk Jain</div>
                <div class="leader-designation">Co-Founder of RhinoMight</div>
            </div>


            <div class="leader-box">
                <div class="leader-avatar-wrapper">
                    <img src="assets/images/Ashim-Matthan.png" alt="Dr. Ashim Roy" class="leader-avatar">
                </div>
                <div class="leader-name">Dr. Ashim Roy</div>
                <div class="leader-designation">Co-Founder of RhinoMight</div>
            </div>

   
            <div class="leader-box">
                <div class="leader-avatar-wrapper">
                    <img src="assets/images/businessman.png" alt="Deepak Das" class="leader-avatar">
                </div>
                <div class="leader-name">Deepak Das</div>
                <div class="leader-designation">A Beacon of Positivity and Wellness at Timeless Monk</div>
            </div> -->

        </div>


        <div class="row g-4 mt-2">
            <!-- Doctor 1 -->
            <div class="col-lg-4 col-md-6">
                <div class="doctor-card">
                    <img src="assets/images/Dr-Kanishka-Jain.png" alt="Kanishk Jain" class="doctor-img">
                    <div class="doctor-info">
                        <h5 class="doctor-name">Dr. Kanishka Jain</h5>
                        <p class="doctor-specialty">
                            Co-Founder of RhinoMight
                        </p>
                    </div>
                </div>
            </div>

            <!-- Doctor 2 -->
            <div class="col-lg-4 col-md-6">
                <div class="doctor-card">
                    <img src="assets/images/Ashim-Matthan.png" alt="Dr. Ashim Roy" class="doctor-img">
                    <div class="doctor-info">
                        <h5 class="doctor-name">Expert Ashim Matthan </h5>
                        <p class="doctor-specialty">
                            Co-Founder of RhinoMight
                        </p>
                    </div>
                </div>
            </div>

            <!-- Doctor 3 -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="doctor-card">
                    <img src="assets/images/businessman.png" alt="Deepak Das" class="doctor-img">
                    <div class="doctor-info">
                        <h5 class="doctor-name">Cosmetologist Deepak Das </h5>
                        <p class="doctor-specialty">
                            A Beacon of Positivity and Wellness at Timeless Monk
                        </p>
                    </div>
                </div>
            </div> -->
        </div>



    </div>
</section>

<!-- Team end========== -->


<!---Blog start-->

<section class="blog-section">
    <div class="container position-relative">

        <!-- Header -->
        <div class="section-header text-center mb-5">
            <h2 class="mb-3">Our Blogs</h2>
            <p class="lead text-muted mx-auto">
                Expert articles on IV therapy, wellness optimization, longevity, and holistic health.
            </p>
        </div>

        <!-- <div class="row g-5">


            <div class="col-lg-4">
                <div class="card blog-card position-relative">
                    <img src="assets/images/blog/Wedeliverwhatwepromise.jpg" class="card-img-top"
                        alt="We Deliver What We Promise">
                    <div class="category-badge">
                        <i class="fa fa-calendar me-1"></i> 5 June, 2026
                    </div>

                    <div class="card-body d-flex flex-column">
                        <h3 class="card-title">We Deliver What We Promise</h3>
                        <p class="text-muted">
                            At Red Monk Wellness, we believe in real people and real results. We pamper you with
                            anything and everything that you require to keep fit..
                        </p>

                        <a href="#" class="btn read-more-btn mt-1">Read More →</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="card blog-card position-relative">
                    <img src="assets/images/blog/Wanttolook10yearsyounger.jpg" class="card-img-top"
                        alt="We Deliver What We Promise">
                    <div class="category-badge">
                        <i class="fa fa-calendar me-1"></i> 30 May, 2026
                    </div>

                    <div class="card-body d-flex flex-column">
                        <h3 class="card-title">Want to look 10 years younger?</h3>
                        <p class="text-muted">
                            Yes, reversing your age and looking considerably younger is very much a reality today thanks
                            to the high efficacy and popularity of HIFU.
                        </p>

                        <a href="#" class="btn read-more-btn mt-1">Read More →</a>
                    </div>
                </div>
            </div>


            <div class="col-lg-4">
                <div class="card blog-card position-relative">
                    <img src="assets/images/blog/ageing.png" class="card-img-top" alt="We Deliver What We Promise">
                    <div class="category-badge">
                        <i class="fa fa-calendar me-1"></i> 01 May, 2026
                    </div>

                    <div class="card-body d-flex flex-column">
                        <h3 class="card-title">Ageing Skin? No More!</h3>
                        <p class="text-muted">
                            In this age of ‘look good and feel good’, none of us want to really look old and aged. And
                            why not?
                        </p>

                        <a href="#" class="btn read-more-btn mt-1">Read More →</a>
                    </div>
                </div>
            </div>


        </div> -->

        <!-- View top 3 blog latest -->
        <div class="row g-5">

            @for (blog of blogs; track blog.ID) {

            <div class="col-lg-4">
                <div class="card blog-card position-relative h-100">

                    <img [src]="baseImageUrl + blog.BannerImage" class="card-img-top" [alt]="blog.Title">

                    <div class="category-badge">
                        <i class="fa fa-calendar me-1"></i>
                        {{ blog.EventDate | date:'dd MMM, yyyy' }}
                    </div>

                    <div class="card-body d-flex flex-column">

                        <h3 class="card-title">
                            {{ blog.Title }}
                        </h3>

                        <p class="text-muted" [innerHTML]="formatDescription(blog.Description)"></p>
                        <!-- {{ blog.Description | slice:0:120 }}
                    @if(blog.Description.length > 120){
                        ...
                    }
                </p> -->

                        <a class="btn read-more-btn mt-auto" [routerLink]="['/blog-details', blog.ID]">
                            Read More →
                        </a>

                    </div>

                </div>
            </div>

            }

        </div>


        <!-- View All Button -->
        <div class="text-center mt-3">
            <a routerLink="/blog" class="btn btn-primary view-all-btn" aria-label="Read more blog articles">

                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true" class="me-2">
                    <path d="M12 7v14" />
                    <path
                        d="M3 18V5a2 2 0 0 1 2-2h3a4 4 0 0 1 4 4 4 4 0 0 1 4-4h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-5a4 4 0 0 0-4 2 4 4 0 0 0-4-2H5a2 2 0 0 1-2-2Z" />
                </svg> -->

                View All Blogs
            </a>
        </div>


    </div>
</section>

<!---Blog end-->


<!-- Walk In & Experience start -->

<section class="pt-section pt-bg-pattern">
    <div class="container">
        <div class="section-header text-center mb-5">
            <h2 class="mb-3">Walk In & Experience</h2>

        </div>
        <div class="row g-4">
            <!-- Card 1 -->
            <div class="col-lg-4 col-md-6">
                <div class="pt-testimonial-card">
                    <!-- <blockquote class="instagram-media"
                        data-instgrm-permalink="https://www.instagram.com/reel/DaW-zDQzxWP/" data-instgrm-version="14">
                    </blockquote> -->
                    <a href="https://www.instagram.com/reel/DaW-zDQzxWP/" target="_blank">
                        <img src="/assets/images/experience/redmonk-wellness1.jpg" alt="Instagram Post 1"
                            class="img-fluid">
                    </a>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="col-lg-4 col-md-6">
                <div class="pt-testimonial-card">

                    <!-- <blockquote class="instagram-media"
                        data-instgrm-permalink="https://www.instagram.com/reel/DaIxgM8zr0Z/?utm_source=ig_embed&utm_campaign=loading"
                        data-instgrm-version="14">
                    </blockquote> -->
                    <a href="https://www.instagram.com/reel/DaIxgM8zr0Z/" target="_blank">
                        <img src="/assets/images/experience/redmonk-wellness2.jpg" alt="Instagram Post 1"
                            class="img-fluid">
                    </a>

                </div>
            </div>

            <!-- Card 3 -->
            <div class="col-lg-4 col-md-6">
                <div class="pt-testimonial-card">

                    <a href="https://www.instagram.com/reel/DZm-tqdzRMi" target="_blank">
                        <img src="/assets/images/experience/redmonk-wellness3.jpg" alt="Instagram Post 1"
                            class="img-fluid">
                    </a>

                    <!-- <blockquote class="instagram-media"
                        data-instgrm-permalink="https://www.instagram.com/reel/DZm-tqdzRMi/?utm_source=ig_embed&utm_campaign=loading"
                        data-instgrm-version="14">
                    </blockquote> -->

                </div>
            </div>
        </div>
    </div>
</section>

<!-- Walk In & Experience end -->


<!-- Before after gallery start -->

<section class="beforeafter-section">
    <div class="container">
        <!-- Header -->
        <div class="section-header">
            <h2 class="section-title">Before & After Results</h2>
            <!-- <p class="lead text-muted mt-3">Transform your wellness journey with our expert care and personalized
                solutions</p> -->
        </div>

        <!-- Custom Tabs -->
        <div class="treatment-nav" id="treatmentNav">
            <div class="treatment-tab active" data-tab="hair">Hair Treatment</div>
            <div class="treatment-tab" data-tab="body">Body Treatment</div>
            <div class="treatment-tab" data-tab="skin">Skin Treatment</div>
        </div>

        <!-- Tab Contents -->
        <div id="tabContents">
            <!-- Hair Content -->
            <div id="hair" class="tab-content active">
                <div class="row g-4">
                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/hair/Exosome-Therapy-for-Hair.jpg"
                                    class="ba-image" alt="Before">
                                <!-- <div class="before-label">BEFORE</div>
                                <div class="after-label">AFTER</div> -->
                                <!-- <div class="ba-overlay">
                                    <div>
                                        <h5 class="text-white mb-1">Dramatic Clarity</h5>
                                    </div>
                                </div> -->
                            </div>
                            <div class="info-block">
                                <!-- <span class="condition-tag">Exosome Therapy for Hair</span> -->
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Exosome Therapy</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 1</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/hair/Hair-Regrowth-Treatment.jpg" class="ba-image"
                                    alt="Before">
                            </div>
                            <div class="info-block">
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Hair Regrowth</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 2</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/hair/Anti-Dandruff-Treatment.jpg" class="ba-image"
                                    alt="Before">
                            </div>
                            <div class="info-block">
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Anti-Dandruff</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 3</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <!-- Body Content -->
            <div id="body" class="tab-content">
                <!-- <div class="row g-4">
                    <div class="col-12 text-center py-5">
                        <h4 class="text-muted">Body transformation results coming soon...</h4>
                        <p class="text-muted">Our body contouring and skin tightening treatments deliver incredible
                            results.</p>
                    </div>
                </div> -->

                <div class="row g-4">
                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/body/Laser-Hair-Reduction-Full-Body.jpg"
                                    class="ba-image" alt="Before">
                                <!-- <div class="before-label">BEFORE</div>
                                <div class="after-label">AFTER</div> -->
                                <!-- <div class="ba-overlay">
                                    <div>
                                        <h5 class="text-white mb-1">Dramatic Clarity</h5>
                                    </div>
                                </div> -->
                            </div>
                            <div class="info-block">
                                <!-- <span class="condition-tag">Exosome Therapy for Hair</span> -->
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Laser Hair Reduction Full Body
                                    </div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 1</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/body/mole-removal.jpg" class="ba-image"
                                    alt="Before">
                            </div>
                            <div class="info-block">
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Mole Removal</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 1</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/body/Laser-Hair-Reduction-Hands-Legs.jpg"
                                    class="ba-image" alt="Before">
                            </div>
                            <div class="info-block">
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Laser Hair Reduction (Hands &
                                        Legs) </div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 3</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>

            <!-- Skin Content -->
            <div id="skin" class="tab-content">
                <div class="row g-4">
                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/skin/PDRN-Hanheal.jpg" class="ba-image"
                                    alt="Before">
                                <!-- <div class="before-label">BEFORE</div>
                                <div class="after-label">AFTER</div> -->
                                <!-- <div class="ba-overlay">
                                    <div>
                                        <h5 class="text-white mb-1">Dramatic Clarity</h5>
                                    </div>
                                </div> -->
                            </div>
                            <div class="info-block">
                                <!-- <span class="condition-tag">Exosome Therapy for Hair</span> -->
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> PDRN (Hanheal)</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 1</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/skin/Profhilo-Face-Neck.jpg" class="ba-image"
                                    alt="Before">
                            </div>
                            <div class="info-block">
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Profhilo Face + Neck</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 2</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                        <div class="result-card h-100">
                            <!-- <div class="clinic-brand">Redmonk Wellness</div> -->
                            <div class="ba-container">
                                <img src="/assets/images/before-after/skin/Collagen-Banking-Rx.jpg" class="ba-image"
                                    alt="Before">
                            </div>
                            <div class="info-block">
                                <div class="meta-info">
                                    <div class="meta-item"><strong>Treatment:</strong> Collagen Banking Rx</div>
                                    <!-- <div class="meta-item"><strong>Sessions:</strong> 3</div>
                                    <div class="meta-item"><strong>Result in:</strong> 4 weeks</div> -->
                                </div>
                                <div class="improvement-bar" style="width: 100%;"></div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>


        </div>
    </div>
</section>

<!-- Before after gallery end -->


<!------Equipment galler start-->

<section class="equipment-gallery">
    <div class="container">
        <!-- Header -->
        <div class="section-header">
            <h2 class="section-title">Our Gallery</h2>
            <!-- <p class="lead text-muted mt-3">Transform your wellness journey with our expert care and personalized
                solutions</p> -->
        </div>

        <!-- Products Grid -->
        <div class="row g-4">
            <!-- Card 1: Supreme-ICE Diode Laser -->
            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/1.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>Supreme-ICE Diode Laser</h5>
                                    <p>Permanent hair removal for all skin tones - painless, fast, and effective in fewer sessions than traditional lasers.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label"> HIFU MACHINE</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/2.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>Fractional CO2 Laser</h5>
                                    <p>Advanced skin resurfacing and scar treatment with precise fractional technology for superior results.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label"> ⁠OXYGENEO MACHINE</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/3.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>4D Ultra HIFU</h5>
                                    <p>Non-invasive face lifting and skin tightening with high-intensity focused ultrasound technology.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label"> ⁠LHR MACHINE LASER HAIR REDUCTION </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/4.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>ADSS 360 Cryo</h5>
                                    <p>Cryolipolysis technology for effective fat reduction and body contouring treatments.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label">FACE STEAMER.</div>
                    </div>
                </div>
            </div>



            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/5.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>Fractional CO2 Laser</h5>
                                    <p>Advanced skin resurfacing and scar treatment with precise fractional technology for superior results.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label">⁠AI FACE ANALYSIS MACHINE
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/6.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>4D Ultra HIFU</h5>
                                    <p>Non-invasive face lifting and skin tightening with high-intensity focused ultrasound technology.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label">FUSION PLASMA MACHINE</div>
                    </div>
                </div>
            </div>


            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/7.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>ADSS 360 Cryo</h5>
                                    <p>Cryolipolysis technology for effective fat reduction and body contouring treatments.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label">HYDRA FACIAL MACHINE</div>
                    </div>
                </div>
            </div>


            <div class="col-lg-3 col-md-6">
                <div class="equip-product-card h-100">
                    <div class="equip-card-image" style="background-image: url('assets/images/equipment/8.jpg');">

                        <!-- <div class="equip-hover-text-overlay">
                                <div>
                                    <h5>ADSS 360 Cryo</h5>
                                    <p>Cryolipolysis technology for effective fat reduction and body contouring treatments.</p>
                                </div>
                            </div> -->

                        <div class="equip-card-label"> ⁠IPL MACHINE</div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>

<!------Equipment galler end-->



<!-- Contact Us Section -->
<section class="contact-section">
    <div class="container">
        <!-- <div class="text-center mb-5">
            <h2 class="section-title display-6">Contact Us</h2>
            <p class="lead text-muted">We'd love to hear from you. Reach out to us anytime.</p>
        </div> -->

        <div class="section-header text-center mb-5">
            <h2 class="mb-3">Contact Us</h2>
            <p class="lead text-muted mx-auto">
                We'd love to hear from you. Reach out to us anytime.
            </p>
        </div>

        <div class="row g-2 justify-content-center">
            <!-- Contact Information -->
            <div class="col-lg-3">
                <div class="info-box h-100">
                    <!-- Email -->
                    <div class="mb-3">
                        <div class="d-flex align-items-center gap-3 mb-3">
                            <div class="contact-icon">
                                <i class="fas fa-envelope"></i>
                            </div>
                            <h4 class="mb-0">EMAIL US</h4>
                        </div>
                        <div class="ms-2 contact-info">
                            <a href="mailto:info@redmonkwellness.com" class="fs-5">
                                info@redmonkwellness.com
                            </a>
                            <br>
                            <a href="https://www.redmonkwellness.com" target="_blank" class="fs-5">
                                www.redmonkwellness.com
                            </a>
                        </div>
                    </div>

                    <!-- Call Us -->
                    <div>
                        <div class="d-flex align-items-center gap-3 mb-3">
                            <div class="contact-icon">
                                <i class="fas fa-phone-volume"></i>
                            </div>
                            <h4 class="mb-0">CALL US</h4>
                        </div>
                        <div class="ms-2 contact-info">
                            <!-- <a href="tel:+916262030303" class="d-block mb-2 fs-5">
                                +91 62-62-03-03-03
                            </a>
                            <a href="tel:+916262662662" class="d-block mb-2 fs-5">
                                +91 62-62-66-26-62
                            </a> -->
                            <a href="tel:+916262620303" class="d-block fs-5">
                                +91 62-62-62-03-03
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mumbai Address -->
            <div class="col-lg-4">
                <div class="contact-card h-100 p-0">
                    <h4 class="address-title mb-3">ADDRESS - MUMBAI</h4>

                    <div class="map-container mb-4">
                        <div class="map-placeholder">
                            <div class="text-center">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.348970519019!2d72.8307769!3d19.1361959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7f51afb0cdd%3A0x1e04ba476ec00617!2sRedmonk%20Wellness!5e0!3m2!1sen!2sin!4v1774066586794!5m2!1sen!2sin"
                                    width="100%" height="180" style="border: 0" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>

                    <p class="">
                        Unit No. B-36, Ground Floor A Wing, Laxmi Business Park, Laxmi Industrial Estate, Sab TV
                        Lane,
                        Off Link Road, Andheri West, Mumbai 400053.
                    </p>
                    <p> <a href="tel:+916262662662" class="d-block mb-2 fs-5">
                            Call Us: +91 62-62-66-26-62
                        </a></p>
                </div>
            </div>

            <!-- Kolkata Address -->
            <div class="col-lg-4">
                <div class="contact-card h-100 p-0">
                    <h4 class="address-title mb-3">ADDRESS - KOLKATA</h4>

                    <div class="map-container mb-4">
                        <div class="map-placeholder">
                            <div class="text-center">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.0200491952346!2d88.35462700000001!3d22.540921700000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277db6219589d%3A0x58c38cf723dfed72!2sRedmonk%20wellness!5e0!3m2!1sen!2sin!4v1774066501830!5m2!1sen!2sin"
                                    width="100%" height="180" style="border: 0" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>

                    <p class="">
                        Crescent Tower, Lala Lajpat Rai Sarani, 229, Acharya Jagdish Chandra Bose Rd, Sreepally,
                        Elgin, Kolkata, West Bengal 700020.
                    </p>

                    <p> <a href="tel:+916262030303" class="d-block mb-2 fs-5">
                            Call Us: +91 62-62-03-03-03
                        </a></p>

                </div>
            </div>
        </div>
    </div>
</section>